import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Family icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Family } from '@sravni/design-system-icons'
 *
 * <Family />
 * ```
 */
var Family = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Family", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.21 9.152a2.083 2.083 0 1 1-2.946 2.946 2.083 2.083 0 0 1 2.946-2.946ZM16.781 4.152a2.083 2.083 0 1 1-2.946 2.946 2.083 2.083 0 0 1 2.946-2.946M15.736 10.209c1.278 0 2.5.444 3.334 1.11M7.638 4.152A2.083 2.083 0 1 1 4.69 7.098a2.083 2.083 0 0 1 2.947-2.946M2.403 11.32c.834-.667 2.056-1.111 3.334-1.111M14.562 16.459c-.971-.751-2.366-1.25-3.826-1.25s-2.855.499-3.826 1.25", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Family };
//# sourceMappingURL=Family.js.map
